import { SelectOptions } from 'app/components/elements/InputSelect';
import { useCallback, useEffect, useState } from 'react';
import { Report } from 'types/report';
import { getReport } from 'services/report';
export const SizeOptionParams = 20;

export const useGetIssues = (roomId?: number) => {
  const [optionIssues, setOptionIssues] = useState<SelectOptions[]>([]);
  const [hasMoreOptionIssues, setHasMoreOptionIssues] = useState<boolean>(false);
  const [pageOptionIssues, setPageOptionIssues] = useState<number>(1);
  const [isLoadingMoreIssues, setIsLoadingMoreIssues] = useState<boolean>(false);

  const fetchInitIssues = useCallback(async () => {
    if (!roomId) return;
    const data = (await getReport({
      page: 1,
      size: SizeOptionParams,
      roomId: roomId.toString()
    })) as { reports: Report[]; total: number };
    setOptionIssues(
      data.reports.map((item: Report) => ({
        label: `${item.name}  -  ${item?.submittedAsset?.name}`,
        value: item.id.toString()
      }))
    );
    if (data.total <= SizeOptionParams) {
      setHasMoreOptionIssues(false);
      return;
    }
    setHasMoreOptionIssues(true);
    setPageOptionIssues(2);
  }, [roomId]);

  useEffect(() => {
    fetchInitIssues();
  }, [fetchInitIssues]);

  // Fetch more issues for pagination
  const fetchMoreIssues = useCallback(async () => {
    if (!hasMoreOptionIssues || isLoadingMoreIssues || !roomId) return;
    try {
      setIsLoadingMoreIssues(true);
      const paramsConvert = {
        page: pageOptionIssues,
        size: SizeOptionParams
      };
      const data = await getReport({
        ...paramsConvert,
        roomId: roomId.toString()
      });

      const dataConvert = data?.reports?.map((item: Report) => ({
        label: `${item.name}  -  ${item?.submittedAsset?.name}`,
        value: item.id.toString()
      }));
      setOptionIssues((prev) => [...prev, ...dataConvert]);
      if (data.total <= SizeOptionParams * pageOptionIssues) {
        setHasMoreOptionIssues(false);
        return;
      }
      setHasMoreOptionIssues(true);
      setPageOptionIssues(pageOptionIssues + 1);
    } finally {
      setIsLoadingMoreIssues(false);
    }
  }, [hasMoreOptionIssues, isLoadingMoreIssues, pageOptionIssues, roomId]);

  return {
    optionIssues,
    hasMoreOptionIssues,
    isLoadingMoreIssues,
    fetchMoreIssues,
    fetchInitIssues
  };
};
